import React from 'react';
import  PageTitle from '../../Components/PageTitle';
import { images } from '../../assets/images';
import { routes } from '../../routes';

function Technologies() {
	return (
		<>
        <PageTitle title="Technologies" />
            <div className="technologies_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                             <div className="technologies_in">
                                    <div className="head_set">
                                        <h3>
                                                Mobility
                                        </h3>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquid natus molestias doloremque ut eaque, deserunt, commodi odit et consequuntur totam repudiandae fugit dolorem eum architecto facilis corrupti nemo voluptatem quibusdam?
                                        </p>
                                    </div>
                                  <div className="technologies_list">
                                       <div className="list_area">
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer2}  alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer1} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer3} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer6} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer4} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer7} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer8} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer9} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer10} alt="../" />
                                                 </div>
                                            </div>
                                       </div>
                                  </div>
                             </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                             <div className="technologies_in">
                                    <div className="head_set">
                                        <h3>
                                            JS & Frontend
                                        </h3>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquid natus molestias doloremque ut eaque, deserunt, commodi odit et consequuntur totam repudiandae fugit dolorem eum architecto facilis corrupti nemo voluptatem quibusdam?
                                        </p>
                                    </div>
                                  <div className="technologies_list">
                                       <div className="list_area">
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer10}  alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer11} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer13} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer12} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer14} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer2} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer34} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer35} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer15} alt="../" />
                                                 </div>
                                            </div>
                                       </div>
                                  </div>
                             </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                             <div className="technologies_in">
                                    <div className="head_set">
                                        <h3>
                                           Backend
                                        </h3>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquid natus molestias doloremque ut eaque, deserunt, commodi odit et consequuntur totam repudiandae fugit dolorem eum architecto facilis corrupti nemo voluptatem quibusdam?
                                        </p>
                                    </div>
                                  <div className="technologies_list">
                                       <div className="list_area">
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer16}  alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer17} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer18} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer20} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer21} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer22} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer19} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer23} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer24} alt="../" />
                                                 </div>
                                            </div>
                                       </div>
                                  </div>
                             </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                             <div className="technologies_in">
                                    <div className="head_set">
                                        <h3>
                                            eCommerce & CMS
                                        </h3>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquid natus molestias doloremque ut eaque, deserunt, commodi odit et consequuntur totam repudiandae fugit dolorem eum architecto facilis corrupti nemo voluptatem quibusdam?
                                        </p>
                                    </div>
                                  <div className="technologies_list">
                                       <div className="list_area">
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer25}  alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer26} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer33} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer32} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer28} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer27} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer31} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer29} alt="../" />
                                                 </div>
                                            </div>
                                            <div className="list_block">
                                                <div className="list_img_set">
                                                    <img src={images.Layer30} alt="../" />
                                                 </div>
                                            </div>
                                       </div>
                                  </div>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
		</>
	);
}

export default Technologies;